import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';

type LiveLinkData = {
  type?: string;
  name?: string;
  description?: string;
  path?: string;
  [key: string]: unknown;
};

type EditCollapsedLiveLinkDialogProps = {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly liveLinkData?: LiveLinkData | null;
  readonly onSaveItem: (item: LiveLinkData) => void;
  readonly onDeleteItem: () => void;
};

export default function EditCollapsedLiveLinkDialog({
  open,
  onClose,
  liveLinkData,
  onSaveItem,
  onDeleteItem,
}: EditCollapsedLiveLinkDialogProps) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [path, setPath] = useState('');

  useEffect(() => {
    if (liveLinkData) {
      setName(liveLinkData.name || '');
      setDescription(liveLinkData.description || '');
      setPath(liveLinkData.path || '');
    } else {
      setName('');
      setDescription('');
      setPath('');
    }
  }, [liveLinkData]);

  const handleSave = () => {
    if (!name.trim()) {
      alert('Link Name is required.');
      return;
    }
    if (!path.trim()) {
      alert('Live Link is required.');
      return;
    }

    onSaveItem({
      ...liveLinkData,
      type: 'url',
      name,
      description,
      path,
    });
  };

  const handleDelete = () => {
    if (globalThis.confirm(`Are you sure you want to delete "${liveLinkData?.name}"?`)) {
      onDeleteItem();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Edit Live Link
        {liveLinkData?.name && (
          <Typography variant="caption" display="block">
            Editing: {liveLinkData.name}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Link Name"
          type="text"
          fullWidth
          variant="standard"
          value={name}
          onChange={(event) => setName(event.target.value)}
          required
        />
        <TextField
          margin="dense"
          id="description"
          label="Description"
          type="text"
          fullWidth
          variant="standard"
          value={description}
          onChange={(event) => setDescription(event.target.value)}
        />
        <TextField
          margin="dense"
          id="path"
          label="Live Link"
          type="text"
          fullWidth
          variant="standard"
          value={path}
          onChange={(event) => setPath(event.target.value)}
          required
        />
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button onClick={onClose} color="inherit" variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          color="error"
          variant="outlined"
          startIcon={<DeleteIcon />}
          disabled={!liveLinkData}
        >
          Delete
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained" startIcon={<SaveIcon />}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
